import { Link } from 'react-router-dom';
import { Consignment } from './api';
import { ConsignmentStatusBadge } from './ConsignmentStatusBadge';
import { DataTableRow } from '../../../shared/components/DataTable';

function formatDate(d: string | null): string {
  if (!d) return '—';
  return new Date(d).toLocaleString();
}

export function consignmentToRow(c: Consignment): DataTableRow {
  return {
    id: c.id,
    cells: [
      <Link to={`/admin/carrier-control/consignments/${c.id}`} key="order">
        {c.shopifyOrderName ?? c.shopifyOrderId}
      </Link>,
      <ConsignmentStatusBadge status={c.status} key="status" />,
      c.tntConsignmentNumber ?? '—',
      c.labelUrl ? (
        <a href={c.labelUrl} target="_blank" rel="noreferrer" key="label">
          Download
        </a>
      ) : (
        '—'
      ),
      formatDate(c.createdAt),
      formatDate(c.lastPolledAt),
    ],
  };
}
